import axios from "axios";
import { apiUrl } from "../constant";

const createInvitation = (email) => {
  return axios.post(`${apiUrl}/api/Onboarding/create-invitation`, {
    email,
  });
};

// Backend contract: POST body with companyIds + sellerIds arrays (AND-combined),
// searchKeywords, pageIndex, pageSize. For non-super-admin callers the server
// overrides the filter arrays with the JWT's CompanyId / SellerId, so the FE
// can safely send empty arrays.
const getInvitations = (pageIndex = 1, pageSize = 10, options = {}) => {
  const { companyIds, sellerIds, searchKeywords } = options;
  const body = {
    pageIndex,
    pageSize,
    companyIds: Array.isArray(companyIds) ? companyIds : [],
    sellerIds: Array.isArray(sellerIds) ? sellerIds : [],
    searchKeywords: typeof searchKeywords === "string" ? searchKeywords.trim() : "",
  };
  return axios.post(`${apiUrl}/api/Onboarding/get-invitations`, body);
};

const getInvitationReferrals = (companySellerId, pageIndex = 1, pageSize = 10) => {
  return axios.get(
    `${apiUrl}/api/Onboarding/get-invitation-referrals?companySellerId=${companySellerId}&pageIndex=${pageIndex}&pageSize=${pageSize}`
  );
};

const deleteInvitation = (id) => {
  return axios.post(`${apiUrl}/api/Onboarding/delete-invitation?id=${id}`);
};

export const OnboardingService = {
  createInvitation,
  getInvitations,
  getInvitationReferrals,
  deleteInvitation,
};

export default OnboardingService;
